import PasswordEdit from '@views/password/PasswordEdit.vue'
import PasswordComplete from '@views/password/PasswordComplete.vue'
export default [
  {
    path: '/user/password/edit',
    name: 'PasswordEdit',
    component: PasswordEdit,
    meta: {
      nav: 'back',
      title: 'パスワード変更',
      gaTitle: 'パスワード変更',
      footer: true
    }
  },
  {
    path: '/user/password/edit/complete',
    name: 'ChangePassword',
    component: PasswordComplete,
    meta: {
      nav: 'none',
      title: 'パスワード変更',
      gaTitle: 'パスワード変更',
      footer: true
    }
  }
]
